module.exports = __webpack_public_path__ + "static/media/fabriken.bd4d7de3.png";